import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../register-builder/builder-module';
import { blockElement } from '../../../register-builder/element-factories';
import { TwoColumnGridSection } from './TwoColumnGridSection';

const twoColBlockDefaults = {
  isPageWidth: false,
  heading: 'Default Heading',
  headingStyle: 'sectionHeader3',
  content: 'This is the default content. Please edit me!',
  contentStyle: 'paragraph1',
  align: 'center',
  mediaSrc: 'https://cdn.zappy.app/6db2607df31caecba4c910998dba31af.png',
} as const;

/**
 * @deprecated
 * This component has been deprecated. `BlockGrid` should be used instead.
 */
export default createBuilderModule(withChildren(TwoColumnGridSection), {
  name: 'TwoColumnSection',
  hideFromInsertMenu: true,
  image: 'https://cdn.zappy.app/95912730bbbb5c8e0cf46127cc12ca67.png',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      defaultValue: 'Default Heading',
    },
  ],
  defaultChildren: [
    blockElement({
      ...twoColBlockDefaults,
      heading: 'Default Heading 01',
    }),
    blockElement({
      ...twoColBlockDefaults,
      heading: 'Default Heading 02',
    }),
  ],
});
